import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, vModelRadio as _vModelRadio, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b45e358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "request-termination-ee" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "body-main" }
const _hoisted_5 = {
  key: 1,
  class: "ls-form"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Legal Profession Uniform General Rules 2015 – Rule 66(2), (3) and (4).", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { style: {"border":"1px solid #D8CFBC","padding":"5px 10px","width":"100%"} }
const _hoisted_10 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_11 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_12 = { class: "data-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Name:", -1))
const _hoisted_14 = { class: "text-field" }
const _hoisted_15 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_16 = { class: "data-box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Email:", -1))
const _hoisted_18 = { class: "text-field" }
const _hoisted_19 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_20 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_21 = { class: "data-box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Firm Name:", -1))
const _hoisted_23 = { class: "text-field" }
const _hoisted_24 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_25 = { class: "data-box" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Phone:", -1))
const _hoisted_27 = { class: "text-field" }
const _hoisted_28 = { style: {"width":"100%"} }
const _hoisted_29 = { class: "data-box" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Address:", -1))
const _hoisted_31 = { class: "text-field" }
const _hoisted_32 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_33 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_34 = { class: "data-box" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Suburb:", -1))
const _hoisted_36 = { class: "text-field" }
const _hoisted_37 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_38 = { class: "data-box" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "State:", -1))
const _hoisted_40 = { class: "text-field" }
const _hoisted_41 = { style: {"width":"100%"} }
const _hoisted_42 = { class: "data-box" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Date appointed:", -1))
const _hoisted_44 = { class: "text-field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Reason for termination:", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "validation-msg" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }),
  /*#__PURE__*/_createTextVNode(" Required field. ")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Search for External Examiner", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-info-circle",
    style: {"font-size":"20px","color":"var(--ls-slate)"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2" }, "To find an External Examiner, please enter a surname below and/or select a region then click 'Search'")
], -1))
const _hoisted_49 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_50 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "External Examiner", -1))
const _hoisted_52 = ["disabled"]
const _hoisted_53 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Suburb/Postcode", -1))
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { style: {"width":"100%","padding":"10px 0","display":"flex","align-items":"center"} }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  key: 0,
  class: "validation-msg error"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "results" }
const _hoisted_63 = { class: "radio" }
const _hoisted_64 = ["id", "value"]
const _hoisted_65 = { class: "radio-elmt" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_67 = { class: "radio-text" }
const _hoisted_68 = { style: {"width":"100%"} }
const _hoisted_69 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_70 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_71 = { class: "data-box" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Name:", -1))
const _hoisted_73 = { class: "text-field" }
const _hoisted_74 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_75 = { class: "data-box" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Email:", -1))
const _hoisted_77 = { class: "text-field" }
const _hoisted_78 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_79 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_80 = { class: "data-box" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Firm Name:", -1))
const _hoisted_82 = { class: "text-field" }
const _hoisted_83 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_84 = { class: "data-box" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Phone:", -1))
const _hoisted_86 = { class: "text-field" }
const _hoisted_87 = { style: {"width":"100%"} }
const _hoisted_88 = { class: "data-box" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Address:", -1))
const _hoisted_90 = { class: "text-field" }
const _hoisted_91 = { style: {"display":"flex","flex-flow":"row nowrap","justify-content":"space-between"} }
const _hoisted_92 = {
  class: "mr-1",
  style: {"width":"50%"}
}
const _hoisted_93 = { class: "data-box" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "Suburb:", -1))
const _hoisted_95 = { class: "text-field" }
const _hoisted_96 = {
  class: "ml-1",
  style: {"width":"50%"}
}
const _hoisted_97 = { class: "data-box" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fieldname" }, "State:", -1))
const _hoisted_99 = { class: "text-field" }
const _hoisted_100 = {
  key: 2,
  class: "showMore mt-2 mb-1"
}
const _hoisted_101 = {
  key: 3,
  class: "validation-msg error mt-2 mb-2"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle fa-lg" }, null, -1))
const _hoisted_103 = { class: "controls mt-4" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      halfScreen: "true",
      onClose: _cache[10] || (_cache[10] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, "Notification of " + _toDisplayString(_ctx.existingEE ? 'Termination' : 'Appointment') + " of External Examiner", 1)
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loadingData)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : (_openBlock(), _createElementBlock("form", _hoisted_5, [
                _createElementVNode("fieldset", null, [
                  _hoisted_6,
                  _hoisted_7,
                  (_ctx.existingEE)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", null, "I, " + _toDisplayString(_ctx.userAccount.user.firstName) + " " + _toDisplayString(_ctx.userAccount.user.lastName) + " the authorised principal(s) of " + _toDisplayString(_ctx.practice?.practice?.practiceName) + " request the approval of the Law Society Council to terminate the appointment of the person listed below as the External Examiner of the law practice for the reasons detailed below:", 1),
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.selectedEE?.firstName ?? '') + " " + _toDisplayString(_ctx.selectedEE?.lastName ?? ''), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _hoisted_17,
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.selectedEE?.email ?? ''), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedEE?.firmName ?? ''), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.selectedEE?.phoneDetail?.phoneNumber ?? ''), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _hoisted_30,
                              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.selectedEE?.address ?? ''), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", _hoisted_34, [
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.selectedEE?.suburb ?? ''), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.selectedEE?.state ?? ''), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                              _hoisted_43,
                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$formatDate(_ctx.selectedEE?.effectiveStartDate)), 1)
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["textarea_box", (!_ctx.reasonForTermination && (_ctx.dirtyFields[0] || _ctx.submitPressed)) ? 'error': '']),
                            style: {"width":"100%"}
                          }, [
                            _hoisted_45,
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.reasonForTermination) = $event)),
                              style: {"border":"1px solid #aaa","height":"130px","resize":"vertical","width":"100%"},
                              maxlength: 5000,
                              placeholder: "Enter reason",
                              onChange: _cache[1] || (_cache[1] = $event => (_ctx.dirtyFields[0] = true))
                            }, null, 544), [
                              [_vModelText, _ctx.reasonForTermination]
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["footnote", [_ctx.reasonForTermination?.length === 5000 ? 'full' : '']])
                            }, _toDisplayString(_ctx.reasonForTermination?.length || 0) + "/5000 characters ", 3),
                            _hoisted_46
                          ], 2)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", null, "I, " + _toDisplayString(_ctx.userAccount.user.firstName) + " " + _toDisplayString(_ctx.userAccount.user.lastName) + " the authorised principal(s) of " + _toDisplayString(_ctx.practice?.practice?.practiceName) + " advise the Law Society Council that I have appointed the person listed below as the external examiner for the above-named law practice.", 1),
                        _hoisted_47,
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["input-box", [_ctx.searchPressed && _ctx.nameKeyword.trim()?.length == 0 && _ctx.suburbPostcode.trim()?.length == 0 ? 'error': '']])
                            }, [
                              _hoisted_51,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.nameKeyword) = $event)),
                                disabled: _ctx.searchinguser,
                                placeholder: "Enter name"
                              }, null, 8, _hoisted_52), [
                                [_vModelText, _ctx.nameKeyword]
                              ])
                            ], 2)
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["input-box", [_ctx.searchPressed && _ctx.nameKeyword.trim()?.length == 0 && _ctx.suburbPostcode.trim()?.length == 0 ? 'error': '']])
                            }, [
                              _hoisted_54,
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.suburbPostcode) = $event)),
                                disabled: _ctx.searchinguser,
                                placeholder: "Enter Suburb/Postcode"
                              }, null, 8, _hoisted_55), [
                                [_vModelText, _ctx.suburbPostcode]
                              ])
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("button", {
                            class: "btn btn-secondary",
                            onClick: _cache[4] || (_cache[4] = _withModifiers($event => {_ctx.searchUser(0, 10, true);}, ["prevent","stop"])),
                            disabled: _ctx.searchinguser || _ctx.gettingMoreUser
                          }, "Search", 8, _hoisted_57),
                          (_ctx.searchinguser)
                            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                                key: 0,
                                class: "loading-indicator ml-2",
                                showLoadingText: false
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.searchPressed && _ctx.nameKeyword.trim()?.length == 0 && _ctx.suburbPostcode.trim()?.length == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _hoisted_59,
                              _createTextVNode(" Please search and select an External Examiner first. ")
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_60,
                        (_ctx.searchPressed && (_ctx.nameKeyword.trim()?.length > 0 || _ctx.suburbPostcode.trim()?.length > 0) && !_ctx.searchinguser)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Found " + _toDisplayString(_ctx.totalResultCount) + " result(s)", 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["search-result", (!this.selectedEE?.id && (_ctx.dirtyFields[0] || _ctx.submitPressed)) ? 'error-no-selection': ''])
                        }, [
                          _createElementVNode("div", _hoisted_62, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.externalExaminers, (ee, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(["ee-item", [_ctx.selectedEE?.id == ee.id ? 'ee-item-selected': '']]),
                                key: i
                              }, [
                                _createElementVNode("label", _hoisted_63, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    name: "ee-user",
                                    id: 'ee-user' + i,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.selectedEE) = $event)),
                                    value: ee,
                                    onChange: _cache[6] || (_cache[6] = $event => (_ctx.dirtyFields[0] = true))
                                  }, null, 40, _hoisted_64), [
                                    [_vModelRadio, _ctx.selectedEE]
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _hoisted_66,
                                    _createElementVNode("span", _hoisted_67, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("div", _hoisted_69, [
                                          _createElementVNode("div", _hoisted_70, [
                                            _createElementVNode("div", _hoisted_71, [
                                              _hoisted_72,
                                              _createElementVNode("div", _hoisted_73, _toDisplayString(ee?.firstName ?? '') + " " + _toDisplayString(ee?.lastName ?? ''), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                              _hoisted_76,
                                              _createElementVNode("div", _hoisted_77, _toDisplayString(ee?.email ?? ''), 1)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_78, [
                                          _createElementVNode("div", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                              _hoisted_81,
                                              _createElementVNode("div", _hoisted_82, _toDisplayString(ee?.firmName ?? ''), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("div", _hoisted_84, [
                                              _hoisted_85,
                                              _createElementVNode("div", _hoisted_86, _toDisplayString(ee?.phoneDetail?.phoneNumber ?? ''), 1)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_87, [
                                          _createElementVNode("div", _hoisted_88, [
                                            _hoisted_89,
                                            _createElementVNode("div", _hoisted_90, _toDisplayString(ee?.address ?? ''), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_91, [
                                          _createElementVNode("div", _hoisted_92, [
                                            _createElementVNode("div", _hoisted_93, [
                                              _hoisted_94,
                                              _createElementVNode("div", _hoisted_95, _toDisplayString(ee?.suburb ?? '') + ", " + _toDisplayString(ee?.postCode ?? ''), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_96, [
                                            _createElementVNode("div", _hoisted_97, [
                                              _hoisted_98,
                                              _createElementVNode("div", _hoisted_99, _toDisplayString(ee?.state ?? ''), 1)
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ], 2),
                        (_ctx.displayShowMoreButton)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              (!_ctx.gettingMoreUser)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "link",
                                    onClick: _cache[7] || (_cache[7] = $event => (_ctx.searchUser(_ctx.numResultsShowing, 10, false)))
                                  }, "Show more"))
                                : _createCommentVNode("", true),
                              (_ctx.gettingMoreUser)
                                ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                                    key: 1,
                                    class: "loading-indicator ml-2",
                                    showLoadingText: false
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        ((!this.selectedEE?.id && (_ctx.dirtyFields[0] || _ctx.submitPressed)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                              _hoisted_102,
                              _createTextVNode(" Please select an External Examiner ")
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                ])
              ]))
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_103, [
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-outline",
            disabled: _ctx.submitting,
            onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, " Back ", 8, _hoisted_104),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.submitting,
            onClick: _cache[9] || (_cache[9] = _withModifiers($event => (_ctx.submitButtonPressed()), ["prevent","stop"]))
          }, " Submit ", 8, _hoisted_105)
        ])
      ]),
      _: 1
    })
  ]))
}